import { Radio } from "antd";
import React from "react";
import { ButtonWrapper } from "./elements.jsx";

import useController from "./useController.js";

const GameFilter = ({ options, onSelect, totalCounts, initialValue }) => {
	const {
		helpers: { translate },
		state: { value },
		handlers: { handleChange },
	} = useController({
		onSelect,
		initialValue,
		totalCounts,
		options,
	});

	return (
		<ButtonWrapper hasOpacity={window.CASINO_GAME_FILTER_BUTTON_HAS_OPACITY}>
			<Radio.Group
				value={value}
				onChange={handleChange}
				optionType="button">
				{options.map((option, index) => (
					<span key={index} data-testid={option.key === "casino" ? "button-filtered-casino-toggle-casino" : "button-filtered-casino-toggle-live"}>
						<Radio.Button
							className={totalCounts?.[option.key] === 0 ? "radio-btn-disabled" : ""}
							value={option.value}
							checked={value === option.value}>
							{option.icon}
							{translate("casino." + option.label)}
						</Radio.Button>
					</span>
				))}
			</Radio.Group>
		</ButtonWrapper>
	);
};

export default GameFilter;
